import CheckBoxIcon from '@mui/icons-material/CheckBox';
import CheckBoxOutlineBlankIcon from '@mui/icons-material/CheckBoxOutlineBlank';
import { Autocomplete,Button,Checkbox,FormControl,InputLabel,ListItemText,MenuItem,Select,TextField,Typography } from "@mui/material";
import { useContext,useEffect,useState } from "react";
import { WebFormContext } from "../../../../context/WebFormContext";
import { trackEventMatomo } from "../../../../helpers/matomo";
import { SubItemFormFilling } from "../../../../types/new-form-filling/types";
import CheckIcon from "../../CheckIcon";
import AdditionalInfo from "../../Structure/AdditionalInfo";

type props = {
  subitem: SubItemFormFilling,
  unico: string | undefined,
  setUnico: Function,
};

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

export default function AutoCompleteUnique({
  subitem,
  unico,
  setUnico }: props) {
  const { ForceUpdate } = useContext(WebFormContext);
  const [changeInput, setChangeInput] = useState(true);

  const textFieldTitle: string = (() => {
    let title = '';
    if (CheckIcon(subitem, unico) === 'naoOk') {
      title += '* ';
    }
    title += `${subitem.id + 1} - ${subitem.nome}`;
    return title;
  })();

  useEffect(() => {
    if (subitem.selecionados) {
      (subitem.selecionados as boolean[])?.find((ele, index: number) => {
        if (ele === true) {
          setUnico((subitem.selecao as string[])[index]);
          return true;
        }
        return false;
      });
    } else if (subitem.padrao !== null) {
      setUnico((subitem?.selecao as string[])[subitem?.padrao as unknown as number]);
      const novo = Array(subitem?.selecao?.length)?.fill(false);
      novo[subitem.padrao as unknown as number] = true;
      subitem.selecionados = novo;
    } if (CheckIcon(subitem, unico) === 'ok' && subitem?.selecionados?.some((ele) => ele === true)) {
      subitem.checked = true;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    const novo = Array(subitem?.selecao?.length)?.fill(false);
    const index = subitem?.selecao?.indexOf(unico as string) ?? -1;
    if (index !== -1 && novo) {
      novo[index] = true;
    }
    if (novo?.includes(true)) {
      subitem.selecionados = novo;
    }
    if (CheckIcon(subitem, unico) === 'ok' && subitem?.selecionados?.some((ele) => ele === true)) {
      subitem.checked = true;
    }
    ForceUpdate();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [unico]);

  function UnicoMobile() {
    return (
      <>
        {changeInput ? <FormControl fullWidth>
          <InputLabel id="demo-simple-select-label">Selecione o valor</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            value={unico}
            label="Selecione o valor"
            renderValue={(selected) => selected}
            onChange={(event) => {
              if (event.target.value) {
                setUnico(event.target.value);
              } if (!event.target.value.length) {
                setUnico('');
                delete subitem.selecionados;
                delete subitem.checked;
              };
            }}
          >
            {subitem?.selecao?.map((option) => {
              const selected = unico === option;
              const SelectionIcon = selected ? CheckBoxIcon : CheckBoxOutlineBlankIcon;
              return (
                <MenuItem key={option} value={option}>
                  <SelectionIcon
                    fontSize="small"
                    style={{ marginRight: 8, padding: 9, boxSizing: 'content-box' }}
                  />
                  <ListItemText primary={option} />
                </MenuItem>
              );
            }
            )}
          </Select>
        </FormControl> :
          <Autocomplete
            style={{
              width: '100%',
              height: '100%',
              backfaceVisibility: 'hidden',
            }}
            renderOption={(props, option, { selected }) => {
              const { key, ...optionProps } = props;
              return (
                <li key={key} {...optionProps}>
                  <Checkbox
                    icon={icon}
                    checkedIcon={checkedIcon}
                    style={{ marginRight: 8 }}
                    checked={selected}
                  />
                  {option}
                </li>
              );
            }}
            disableCloseOnSelect
            className={`${subitem.itemid}|${subitem.id}`}
            onClick={() => trackEventMatomo('formSubitem', 'click', 'input', 'edita valor')}
            noOptionsText={'Sem opções...'}
            loadingText={'Carregando...'}
            autoComplete
            value={unico ?? null}
            getOptionLabel={option => option as string}
            isOptionEqualToValue={(option, value) => option === value}
            fullWidth
            options={subitem?.selecao?.map((option) => option) || []}
            onChange={(event: React.SyntheticEvent, newValue: string | number | null) => {
              event.preventDefault();
              setUnico(newValue);
              if (!newValue) {
                setUnico('');
                delete subitem.selecionados;
              }
            }}
            renderInput={(params) =>
              <TextField
                required={subitem.obrigatoriedade?.preenchimento}
                {...params}
                placeholder="Selecione o valor"
                InputLabelProps={{ shrink: true }}
              />}
          />}
        <Button onClick={() => setChangeInput(!changeInput)}>{`${changeInput ? 'Habilitar autocomplete' : 'Desabilitar autocomplete'}`}</Button>
      </>
    );
  }

  function UnicoWeb() {
    return (
      <Autocomplete
        style={{
          width: '100%',
          height: '100%',
          backfaceVisibility: 'hidden',
        }}
        renderOption={(props, option, { selected }) => {
          const { key, ...optionProps } = props;
          return (
            <li key={key} {...optionProps}>
              <Checkbox
                icon={icon}
                checkedIcon={checkedIcon}
                style={{ marginRight: 8 }}
                checked={selected}
              />
              {option}
            </li>
          );
        }}
        disableCloseOnSelect
        className={`${subitem.itemid}|${subitem.id}`}
        onClick={() => trackEventMatomo('formSubitem', 'click', 'input', 'edita valor')}
        noOptionsText={'Sem opções...'}
        loadingText={'Carregando...'}
        autoComplete
        value={unico ?? null}
        getOptionLabel={option => option as string}
        isOptionEqualToValue={(option, value) => option === value}
        fullWidth
        options={subitem?.selecao?.map((option) => option) || []}
        onChange={(event: React.SyntheticEvent, newValue: string | number | null) => {
          event.preventDefault();
          setUnico(newValue);
          if (!newValue) {
            setUnico('');
            delete subitem.selecionados;
          }
        }}
        renderInput={(params) =>
          <TextField
            required={subitem.obrigatoriedade?.preenchimento}
            {...params}
            placeholder="Selecione o valor"
            InputLabelProps={{ shrink: true }}
          />}
      />);
  }
  return (
    <>
      <Typography
        variant='h6'
        style={{
          wordBreak: 'break-all',
          marginBottom: '5px',
          width: '100%',
          textAlign: 'left'
        }}>
        {textFieldTitle}
      </Typography>
      {navigator.userAgent.includes('Mobile') || navigator.userAgent.includes('Android/iPhone')
        ? <UnicoMobile />
        : <UnicoWeb />}
      {unico && unico?.length > 0 && <AdditionalInfo subItem={subitem} />}
    </>
  );
}